<template>
  <div class="page-content">
    <div class="welcome-section">
      <h1 class="welcome-title">Tervetuloa Raviremmiin!</h1>
      <p class="welcome-text">
        Kilpaile pisteistä oikeiden ravilähtöjen perusteella. Voit myös pelata ryhmässä ja haastaa ystäväsi!
      </p>
      <p v-if="!isAuthenticated" class="auth-prompt">
        <router-link to="/sign-in" class="auth-link">Kirjautumalla</router-link> tai
        <router-link to="/sign-up" class="auth-link">Rekisteröitymällä</router-link> voit hallita remmiäsi ja nähdä hevosten, ohjastajien ja pelaajien tuloksia.
      </p>
      
      <HomeNews />
    </div>


    <div class="leaderboards-container">

      <div class="leaderboard-section daily-player-leaderboard">
        <div class="leaderboard-header">
          <div class="header-with-image">
            <img src="@/assets/player.webp" alt="Player" class="header-image" />
            <h3>Päivän parhaat pelaajat</h3>
          </div>
          <span class="date-badge">{{ dailyTopPlayersData && dailyTopPlayersData.length > 0 ? dailyTopPlayersData[0].Date : 'Viimeisin' }}</span>
        </div>
        <div v-if="isDailyPlayerLoading" class="loading-message">
          <div class="loading-spinner"></div>
          <span>Ladataan päivän pelaajia...</span>
        </div>
        <div v-else-if="dailyPlayerError" class="no-data-message">Jakso ei ole vielä alkanut.</div>
        <div v-else-if="dailyTopPlayersData && dailyTopPlayersData.length > 0">
          <ol class="leaderboard-list">
            <li v-for="(player, index) in dailyTopPlayersData" :key="'daily-player-' + player.PlayerID" class="leaderboard-item">
              <span class="rank">{{ index + 1 }}.</span>
              <span
                class="name"
                :class="{ 'cursor-pointer hover:underline': isAuthenticated }"
                @click="isAuthenticated ? openPlayerTeamModal(player.PlayerID, player.username) : null"
                :title="isAuthenticated ? 'Näytä ' + player.username + ' remmi' : ''"
              >
                {{ player.username }}
              </span>
              <span class="points">{{ player.points_earned_today }} p</span>
            </li>
          </ol>
        </div>
        <div v-else class="no-data-message">Jakso ei ole vielä alkanut.</div>
      </div>

      <div class="leaderboard-section daily-horse-leaderboard">
        <div class="leaderboard-header">
          <div class="header-with-image">
            <img src="@/assets/heppa2.webp" alt="Horse" class="header-image" />
            <h3>Päivän parhaat hevoset</h3>
          </div>
          <span class="date-badge">{{ dailyLeaderboardDate || 'Viimeisin' }}</span>
        </div>
        <div v-if="isDailyLoading" class="loading-message">
          <div class="loading-spinner"></div>
          <span>Ladataan päivän tuloksia...</span>
        </div>
          <div v-else-if="dailyError" class="no-data-message">Ei päivän hevostietoja saatavilla.</div>
          <div v-else-if="sortedDailyTopHorses.length > 0">
            <ol class="leaderboard-list">
              <li v-for="(horse) in sortedDailyTopHorses" :key="'daily-horse-' + horse.ID" class="leaderboard-item">
                <span class="rank">{{ getRankFromType(horse.RankType) }}.</span>
                <span
                  class="name"
                  :class="{ 'cursor-pointer hover:underline': isAuthenticated }"
                  @click="isAuthenticated ? openHorsePerformanceModal(horse.ID, horse.Name) : null"
                  :title="isAuthenticated ? 'Näytä ' + horse.Name + ' suoritukset' : ''"
                >
                  {{ horse.Name }}
                </span>
                <span class="points">{{ horse.Points }} p</span>
              </li>
            </ol>
          </div>
          <div v-else class="no-data-message">Jakso ei ole vielä alkanut.</div>
        </div>

      <div class="leaderboard-section daily-jockey-leaderboard">
        <div class="leaderboard-header">
          <div class="header-with-image">
            <img src="@/assets/jockey.webp" alt="Jockey" class="header-image" />
            <h3>Päivän parhaat ohjastajat</h3>
          </div>
          <span class="date-badge">{{ dailyLeaderboardDate || 'Viimeisin' }}</span>
        </div>
        <div v-if="isDailyLoading" class="loading-message">
          <div class="loading-spinner"></div>
          <span>Ladataan päivän tuloksia...</span>
        </div>
          <div v-else-if="dailyError" class="no-data-message">Ei päivän ohjastajatietoja saatavilla.</div>
            <div v-else-if="sortedDailyTopJockeys.length > 0">
            <ol class="leaderboard-list">
              <li v-for="(jockey) in sortedDailyTopJockeys" :key="'daily-jockey-' + jockey.ID" class="leaderboard-item">
                <span class="rank">{{ getRankFromType(jockey.RankType) }}.</span>
                <span
                  class="name"
                  :class="{ 'cursor-pointer hover:underline': isAuthenticated }"
                  @click="isAuthenticated ? openJockeyPerformanceModal(jockey.ID, jockey.Name) : null"
                  :title="isAuthenticated ? 'Näytä ' + jockey.Name + ' suoritukset' : ''"
                >
                  {{ jockey.Name }}
                </span>
                <span class="points">{{ jockey.Points }} p</span>
              </li>
            </ol>
          </div>
          <div v-else class="no-data-message">Jakso ei ole vielä alkanut.</div>
        </div>

      <div class="leaderboard-section player-leaderboard">
        <div class="leaderboard-header">
          <div class="header-with-image">
            <img src="@/assets/player.webp" alt="Player" class="header-image" />
            <h3>Jakson parhaat pelaajat</h3>
          </div>
        </div>
        <div v-if="isPlayerLoading" class="loading-message">
          <div class="loading-spinner"></div>
          <span>Ladataan pelaajia...</span>
        </div>
        <div v-else-if="playerError" class="error-message">Virhe: {{ playerError }}</div>
        <div v-else-if="top10Players.length > 0">
          <ol class="leaderboard-list">
            <li v-for="(player, index) in top10Players" :key="'player-' + player.PlayerID" class="leaderboard-item">
              <span class="rank">{{ index + 1 }}.</span>
              <span
                class="name"
                :class="{ 'cursor-pointer hover:underline': isAuthenticated }"
                @click="isAuthenticated ? openPlayerTeamModal(player.PlayerID, player.username) : null"
                :title="isAuthenticated ? 'Näytä ' + player.username + ' remmi' : ''"
              >
                {{ player.username }}
              </span>
              <span class="points">{{ player.total_points }} p</span>
            </li>
          </ol>
        </div>
        <div v-else class="no-data-message">Ei pelaajatietoja vielä.</div>
      </div>

      <div class="leaderboard-section period-stats-leaderboard">
        <div class="leaderboard-header">
          <div class="header-with-image">
            <img src="@/assets/kolikot.webp" alt="Stats" class="header-image" />
            <h3>Jakson erikoistilastot</h3>
          </div>
        </div>
        <div v-if="isPeriodStatsLoading" class="loading-message">
          <div class="loading-spinner"></div>
          <span>Ladataan jakson tilastoja...</span>
        </div>
        <div v-else-if="periodStatsError" class="error-message">Virhe: {{ periodStatsError }}</div>
        <div v-else class="period-stats-grid">
          <div class="period-stat-column">
            <h4>Eniten voittoja</h4>
            <ol v-if="topHorseWins.length > 0" class="leaderboard-list compact-list">
              <li v-for="(player, index) in topHorseWins" :key="'wins-' + player.PlayerID" class="leaderboard-item">
                <span class="rank">{{ index + 1 }}.</span>
                <span
                  class="name"
                  :class="{ 'cursor-pointer hover:underline': isAuthenticated }"
                  @click="isAuthenticated ? openPlayerTeamModal(player.PlayerID, player.username) : null"
                >
                  {{ player.username }}
                </span>
                <span class="points">{{ player.value }} voittoa</span>
              </li>
            </ol>
            <div v-else class="no-data-message small-message">Ei voittoja vielä.</div>
          </div>
          <div class="period-stat-column">
            <h4>Eniten rahaa</h4>
            <ol v-if="topHorsePrizeSum.length > 0" class="leaderboard-list compact-list">
              <li v-for="(player, index) in topHorsePrizeSum" :key="'prize-' + player.PlayerID" class="leaderboard-item">
                <span class="rank">{{ index + 1 }}.</span>
                <span
                  class="name"
                  :class="{ 'cursor-pointer hover:underline': isAuthenticated }"
                  @click="isAuthenticated ? openPlayerTeamModal(player.PlayerID, player.username) : null"
                >
                  {{ player.username }}
                </span>
                <span class="points">{{ formatEuro(player.value) }}</span>
              </li>
            </ol>
            <div v-else class="no-data-message small-message">Ei voittorahaa vielä.</div>
          </div>
          <div class="period-stat-column">
            <h4>Eniten keulapaikkoja</h4>
            <ol v-if="topHorseLeadCount.length > 0" class="leaderboard-list compact-list">
              <li v-for="(player, index) in topHorseLeadCount" :key="'leads-' + player.PlayerID" class="leaderboard-item">
                <span class="rank">{{ index + 1 }}.</span>
                <span
                  class="name"
                  :class="{ 'cursor-pointer hover:underline': isAuthenticated }"
                  @click="isAuthenticated ? openPlayerTeamModal(player.PlayerID, player.username) : null"
                >
                  {{ player.username }}
                </span>
                <span class="points">{{ player.value }} kpl</span>
              </li>
            </ol>
            <div v-else class="no-data-message small-message">Ei keulapaikkoja vielä.</div>
          </div>
          <div class="period-stat-column">
            <h4>Suurimmat päiväpistepotit</h4>
            <ol v-if="topBestDailyScores.length > 0" class="leaderboard-list compact-list">
              <li v-for="(player, index) in topBestDailyScores" :key="'daily-score-' + player.PlayerID + '-' + player.Date" class="leaderboard-item">
                <span class="rank">{{ index + 1 }}.</span>
                <span
                  class="name"
                  :class="{ 'cursor-pointer hover:underline': isAuthenticated }"
                  @click="isAuthenticated ? openPlayerTeamModal(player.PlayerID, player.username) : null"
                >
                  {{ player.username }}
                </span>
                <span class="points daily-score-points">{{ player.value }} p <span class="stat-date">{{ formatShortDate(player.Date) }}</span></span>
              </li>
            </ol>
            <div v-else class="no-data-message small-message">Ei päiväscoreja vielä.</div>
          </div>
        </div>
      </div>

      <div class="leaderboard-section horse-leaderboard">
        <div class="leaderboard-header">
          <div class="header-with-image">
            <img src="@/assets/heppa2.webp" alt="Horse" class="header-image" />
            <h3>Jakson parhaat hevoset</h3>
          </div>
        </div>
        <div v-if="isHorseLoading" class="loading-message">
          <div class="loading-spinner"></div>
          <span>Ladataan hevosia...</span>
        </div>
        <div v-else-if="horseError" class="error-message">Virhe: {{ horseError }}</div>
        <div v-else-if="top10Horses.length > 0">
          <ol class="leaderboard-list">
          <li
              v-for="(horse, index) in top10Horses"
              :key="'horse-' + (horse.horse_id || index)"
              class="leaderboard-item"
          >
              <span class="rank">{{ index + 1 }}.</span>
              <span
              class="name"
              :class="{ 'cursor-pointer hover:underline': horse.horse_id && isAuthenticated, 'opacity-50 cursor-default': !horse.horse_id }"
              @click="horse.horse_id && isAuthenticated ? openHorsePerformanceModal(horse.horse_id, horse.horse_name) : null" :title="horse.horse_id && isAuthenticated
                      ? 'Näytä ' + horse.horse_name + ' suoritukset'
                      : isAuthenticated ? 'Suoritustietoja ei saatavilla' : ''"
              >
              {{ horse.horse_name || 'N/A' }}
              </span>
              <span class="points">{{ horse.total_points }} p</span>
          </li>
          </ol>
        </div>
        <div v-else class="no-data-message">Ei hevostietoja vielä.</div>
      </div>

      <div class="leaderboard-section jockey-leaderboard">
        <div class="leaderboard-header">
          <div class="header-with-image">
            <img src="@/assets/jockey.webp" alt="Jockey" class="header-image" />
            <h3>Jakson parhaat ohjastajat</h3>
          </div>
        </div>
        <div v-if="isJockeyLoading" class="loading-message">
          <div class="loading-spinner"></div>
          <span>Ladataan ohjastajia...</span>
        </div>
        <div v-else-if="jockeyError" class="error-message">Virhe: {{ jockeyError }}</div>
        <div v-else-if="top10Jockeys.length > 0">
          <ol class="leaderboard-list">
              <li v-for="(jockey, index) in top10Jockeys" :key="'jockey-' + (jockey.jockey_id || index)" class="leaderboard-item">
              <span class="rank">{{ index + 1 }}.</span>
              <span
                class="name"
                :class="{ 'cursor-pointer hover:underline': jockey.jockey_id && isAuthenticated, 'opacity-50 cursor-default': !jockey.jockey_id }"
                @click="jockey.jockey_id && isAuthenticated ? openJockeyPerformanceModal(jockey.jockey_id, jockey.jockey_name) : null" :title="jockey.jockey_id && isAuthenticated
                        ? 'Näytä ' + jockey.jockey_name + ' suoritukset'
                        : isAuthenticated ? 'Suoritustietoja ei saatavilla' : ''"
              >
              {{ jockey.jockey_name || 'N/A' }}
              </span>
              <span class="points">{{ jockey.total_points }} p</span>
              </li>
          </ol>
        </div>
        <div v-else class="no-data-message">Ei ohjastajatietoja vielä.</div>
      </div>

    </div>

    <Teleport to="body">
      <PlayerTeamModal
        :show="isPlayerTeamModalVisible"
        :player-id="selectedPlayerId"
        :player-name="selectedPlayerName"
        @close="closePlayerTeamModal"
        @viewHorse="handleViewHorse"
        @viewJockey="handleViewJockey"
      />
    </Teleport>

    <Teleport to="body">
      <HorsePerformanceModal
          :show="isHorsePerformanceModalVisible"
          :horse-id="selectedHorseId"
          :horse-name="selectedHorseName"
          @close="closeHorsePerformanceModal"
      />
    </Teleport>

    <Teleport to="body">
      <JockeyPerformanceModal
          :show="isJockeyPerformanceModalVisible"
          :jockey-id="selectedJockeyId"
          :jockey-name="selectedJockeyName"
          @close="closeJockeyPerformanceModal"
      />
    </Teleport>
    </div>
</template>

<script>
import { ref, onMounted, inject, computed, watch } from 'vue';
import HomeNews from './HomeNews.vue';
import axios from '../plugins/axios'; // Configured instance for authenticated calls

// **** MODAL IMPORTS ****
import PlayerTeamModal from './PlayerTeamModal.vue'; // Adjust path if necessary
import HorsePerformanceModal from './HorsePerformanceModal.vue'; // Adjust path if necessary
import JockeyPerformanceModal from './JockeyPerformanceModal.vue'; // Adjust path if necessary

export default {
  name: 'HomePage',
  // **** REGISTER MODAL COMPONENTS ****
  components: {
    HomeNews,
    PlayerTeamModal,
    HorsePerformanceModal,
    JockeyPerformanceModal,
  },
  setup() {
    // --- Injected State ---
    const isAuthenticated = inject('isAuthenticated');

    // --- State Variables ---
    // Overall Leaderboards
    const playerLeaderboardData = ref([]);
    const isPlayerLoading = ref(false);
    const playerError = ref(null);
    const horseLeaderboardData = ref([]);
    const isHorseLoading = ref(false);
    const horseError = ref(null);
    const jockeyLeaderboardData = ref([]);
    const isJockeyLoading = ref(false);
    const jockeyError = ref(null);
    const periodTopStatsData = ref({
      horseWins: [],
      horsePrizeSum: [],
      horseLeadCount: [],
      bestDailyScores: [],
    });
    const isPeriodStatsLoading = ref(false);
    const periodStatsError = ref(null);

    // Daily Leaderboards (Raw Fetched Data)
    const dailyLeaderboardDate = ref(null);
    const rawDailyTopHorses = ref([]);
    const rawDailyTopJockeys = ref([]);
    const isDailyLoading = ref(false);
    const dailyError = ref(null);

    // State for Daily Players
    const dailyTopPlayersData = ref([]);
    const isDailyPlayerLoading = ref(false);
    const dailyPlayerError = ref(null);

    // **** MODAL STATE VARIABLES ****
    // Player Team Modal
    const isPlayerTeamModalVisible = ref(false);
    const selectedPlayerId = ref(null);
    const selectedPlayerName = ref('');

    // Horse Performance Modal
    const isHorsePerformanceModalVisible = ref(false);
    const selectedHorseId = ref(null);
    const selectedHorseName = ref('');

    // Jockey Performance Modal
    const isJockeyPerformanceModalVisible = ref(false);
    const selectedJockeyId = ref(null);
    const selectedJockeyName = ref('');
    // **** END OF MODAL STATE VARIABLES ****


    // --- Helper function ---
    const getRankFromType = (rankType) => {
        if (!rankType || !rankType.includes('#')) return '?';
        return parseInt(rankType.split('#')[1], 10);
    };

    const formatEuro = (value) => {
      const amount = Number(value || 0);
      return `${amount.toLocaleString('fi-FI')} €`;
    };

    const formatShortDate = (value) => {
      if (!value) return '';
      const parts = String(value).split('-');
      if (parts.length !== 3) return value;
      return `${Number(parts[2])}.${Number(parts[1])}.`;
    };

    // --- Fetch Methods (Updated for paginated total_points API) ---
    const fetchPlayerLeaderboard = async () => {
      isPlayerLoading.value = true; playerError.value = null;
      try {
        // Add limit parameter to get only top players (for homepage we just need a few)
        const endpoint = `${process.env.VUE_APP_API_BASE_URL}/total_points?limit=20`;
        const response = await axios.get(endpoint);
        
        // Handle the new paginated response format
        if (response.data && response.data.items && Array.isArray(response.data.items)) {
            playerLeaderboardData.value = response.data.items.filter(p => p.PlayerID);
            if (playerLeaderboardData.value.length !== response.data.items.length) {
                console.warn("Some players in total_points response missing PlayerID");
            }
        } else if (Array.isArray(response.data)) {
            // Fallback for old API format (just in case)
            playerLeaderboardData.value = response.data.filter(p => p.PlayerID);
            if (playerLeaderboardData.value.length !== response.data.length) {
                console.warn("Some players in total_points response missing PlayerID");
            }
        } else { 
            console.error("Unexpected response format:", response.data);
            throw new Error("Unexpected player data format received from API."); 
        }
      } catch (err) { console.error('Error fetching player leaderboard:', err); playerError.value = err.response?.data?.error || err.message || 'Could not load player leaderboard.'; playerLeaderboardData.value = []; }
      finally { isPlayerLoading.value = false; }
    };

    const fetchTopHorses = async () => {
        isHorseLoading.value = true; 
        horseError.value = null;
        try {
            const endpoint = `${process.env.VUE_APP_API_BASE_URL}/top_horses`;
            const response = await axios.get(endpoint);
            if (Array.isArray(response.data)) {
                horseLeaderboardData.value = response.data;
                if (response.data.slice(0, 10).some(h => !h.horse_id)) {
                    console.warn("Some top horses in the list might be missing 'horse_id'.");
                }
            } else {
                console.error("Unexpected horse data format (top_horses):", response.data);
                throw new Error("Unexpected horse data format received from API.");
            }
        } catch (err) { console.error('Error fetching overall horse leaderboard:', err); horseError.value = err.response?.data?.error || err.message || 'Could not load overall horse leaderboard.'; horseLeaderboardData.value = []; }
        finally { isHorseLoading.value = false; }
    };

    const fetchTopJockeys = async () => {
        isJockeyLoading.value = true; 
        jockeyError.value = null;
        try {
            const endpoint = `${process.env.VUE_APP_API_BASE_URL}/top_jockeys`;
            const response = await axios.get(endpoint);
            if (Array.isArray(response.data)) {
                jockeyLeaderboardData.value = response.data;
                if (response.data.slice(0, 10).some(j => !j.jockey_id)) {
                    console.warn("Some top jockeys in the list might be missing 'jockey_id'.");
                }
            } else {
                console.error("Unexpected jockey data format (top_jockeys):", response.data);
                throw new Error("Unexpected jockey data format received from API.");
            }
        } catch (err) { console.error('Error fetching overall jockey leaderboard:', err); jockeyError.value = err.response?.data?.error || err.message || 'Could not load overall jockey leaderboard.'; jockeyLeaderboardData.value = []; }
        finally { isJockeyLoading.value = false; }
    };

    const fetchPeriodTopStats = async () => {
        isPeriodStatsLoading.value = true;
        periodStatsError.value = null;
        try {
            const endpoint = `${process.env.VUE_APP_API_BASE_URL}/period_top_stats`;
            const response = await axios.get(endpoint);
            if (response.data && typeof response.data === 'object') {
                periodTopStatsData.value = {
                  horseWins: Array.isArray(response.data.horseWins) ? response.data.horseWins : [],
                  horsePrizeSum: Array.isArray(response.data.horsePrizeSum) ? response.data.horsePrizeSum : [],
                  horseLeadCount: Array.isArray(response.data.horseLeadCount) ? response.data.horseLeadCount : [],
                  bestDailyScores: Array.isArray(response.data.bestDailyScores) ? response.data.bestDailyScores : [],
                };
            } else {
                throw new Error("Unexpected period top stats data format");
            }
        } catch (err) {
            console.error('Error fetching period top stats:', err);
            periodStatsError.value = err.response?.data?.error || err.message || 'Could not load period top stats.';
            periodTopStatsData.value = { horseWins: [], horsePrizeSum: [], horseLeadCount: [], bestDailyScores: [] };
        } finally {
            isPeriodStatsLoading.value = false;
        }
    };

    const fetchDailyTopPerformers = async () => {
        // Remove authentication check to allow public access
        isDailyLoading.value = true; dailyError.value = null;
        rawDailyTopHorses.value = []; rawDailyTopJockeys.value = [];
        try {
            const endpoint = `${process.env.VUE_APP_API_BASE_URL}/daily_top_jockeys_horses`;
            const response = await axios.get(endpoint);
            if (response.data && typeof response.data === 'object') {
                dailyLeaderboardDate.value = response.data.date || null;
                rawDailyTopHorses.value = Array.isArray(response.data.horses) ? response.data.horses.filter(h => h.ID) : [];
                rawDailyTopJockeys.value = Array.isArray(response.data.jockeys) ? response.data.jockeys.filter(j => j.ID) : [];
                if (rawDailyTopHorses.value.length !== (response.data.horses || []).length) console.warn("Some daily horses missing ID");
                if (rawDailyTopJockeys.value.length !== (response.data.jockeys || []).length) console.warn("Some daily jockeys missing ID");
            } else { throw new Error("Unexpected daily performers data format"); }
        } catch (err) { console.error('Error fetching daily performers:', err); dailyError.value = err.response?.data?.error || err.message || 'Could not load daily performers.'; dailyLeaderboardDate.value = null; rawDailyTopHorses.value = []; rawDailyTopJockeys.value = []; }
        finally { isDailyLoading.value = false; }
    };

    const fetchDailyTopPlayers = async () => {
        // Remove authentication check to allow public access
        isDailyPlayerLoading.value = true; dailyPlayerError.value = null;
        try {
            const endpoint = `${process.env.VUE_APP_API_BASE_URL}/daily_top_players`;
            const response = await axios.get(endpoint);
            if (Array.isArray(response.data)) {
                dailyTopPlayersData.value = response.data.filter(p => p.PlayerID);
                if (dailyTopPlayersData.value.length !== response.data.length) console.warn("Some daily players missing PlayerID");
            } else { throw new Error("Unexpected daily player data format"); }
        } catch (err) { console.error('Error fetching daily player leaderboard:', err); dailyPlayerError.value = err.response?.data?.error || err.response?.data?.message || 'Could not load daily player leaderboard.'; dailyTopPlayersData.value = []; }
        finally { isDailyPlayerLoading.value = false; }
    };


    // **** MODAL CONTROL FUNCTIONS ****
    // Player Team Modal
    const openPlayerTeamModal = (playerId, playerName) => {
      if (!playerId) {
        console.error("Cannot open player team modal without PlayerID.");
        return;
      }
      selectedPlayerId.value = playerId;
      selectedPlayerName.value = playerName || 'Selected Player';
      isPlayerTeamModalVisible.value = true;
      // Close other modals when opening this one
      closeHorsePerformanceModal();
      closeJockeyPerformanceModal();
    };
    const closePlayerTeamModal = () => {
      isPlayerTeamModalVisible.value = false;
      // Optionally clear selected player details
      // selectedPlayerId.value = null;
      // selectedPlayerName.value = '';
    };

    // Horse Performance Modal
    const openHorsePerformanceModal = (horseId, horseName) => {
      if (!horseId) {
        console.warn("Cannot show performance for horse without ID.");
        return;
      }
      selectedHorseId.value = horseId;
      selectedHorseName.value = horseName || 'Selected Horse';
      isHorsePerformanceModalVisible.value = true;
      // Close other modals
      // closePlayerTeamModal(); // Decide if player modal should close
      closeJockeyPerformanceModal();
    };
    const closeHorsePerformanceModal = () => {
      isHorsePerformanceModalVisible.value = false;
      selectedHorseId.value = null;
      selectedHorseName.value = '';
    };

    // Jockey Performance Modal
    const openJockeyPerformanceModal = (jockeyId, jockeyName) => {
      if (!jockeyId) {
        console.warn("Cannot show performance for jockey without ID.");
        return;
      }
      selectedJockeyId.value = jockeyId;
      selectedJockeyName.value = jockeyName || 'Selected Jockey';
      isJockeyPerformanceModalVisible.value = true;
      // Close other modals
      // closePlayerTeamModal(); // Decide if player modal should close
      closeHorsePerformanceModal();
    };
    const closeJockeyPerformanceModal = () => {
      isJockeyPerformanceModalVisible.value = false;
      selectedJockeyId.value = null;
      selectedJockeyName.value = '';
    };

    // Event Handlers from PlayerTeamModal (to open performance modals)
    const handleViewHorse = (payload) => {
      console.log("HomePage received viewHorse event:", payload);
      if (payload && payload.horseId) {
        openHorsePerformanceModal(payload.horseId, payload.horseName);
      } else {
        console.warn("Invalid payload received for viewHorse event in HomePage.");
      }
    };
    const handleViewJockey = (payload) => {
      console.log("HomePage received viewJockey event:", payload);
      if (payload && payload.jockeyId) {
        openJockeyPerformanceModal(payload.jockeyId, payload.jockeyName);
      } else {
        console.warn("Invalid payload received for viewJockey event in HomePage.");
      }
    };
    // **** END OF MODAL CONTROL FUNCTIONS ****


    // --- Computed Properties ---
    const top10Players = computed(() => playerLeaderboardData.value.slice(0, 10));
    const top10Horses = computed(() => horseLeaderboardData.value.slice(0, 10));
    const top10Jockeys = computed(() => jockeyLeaderboardData.value.slice(0, 10));
    const topHorseWins = computed(() => periodTopStatsData.value.horseWins.slice(0, 5));
    const topHorsePrizeSum = computed(() => periodTopStatsData.value.horsePrizeSum.slice(0, 5));
    const topHorseLeadCount = computed(() => periodTopStatsData.value.horseLeadCount.slice(0, 5));
    const topBestDailyScores = computed(() => periodTopStatsData.value.bestDailyScores.slice(0, 5));

    const sortedDailyTopHorses = computed(() => {
        return [...rawDailyTopHorses.value].sort((a, b) => {
            const rankA = getRankFromType(a.RankType); const rankB = getRankFromType(b.RankType);
            return (isNaN(rankA) || isNaN(rankB)) ? 0 : rankA - rankB;
        });
    });
    const sortedDailyTopJockeys = computed(() => {
        return [...rawDailyTopJockeys.value].sort((a, b) => {
            const rankA = getRankFromType(a.RankType); const rankB = getRankFromType(b.RankType);
            return (isNaN(rankA) || isNaN(rankB)) ? 0 : rankA - rankB;
        });
    });

    // --- Lifecycle Hook ---
    onMounted(() => {
      // Fetch all leaderboards regardless of auth state
      fetchPlayerLeaderboard();
      fetchTopHorses();
      fetchTopJockeys();
      fetchPeriodTopStats();
      fetchDailyTopPerformers();
      fetchDailyTopPlayers();
    });

    // --- Watch for Authentication Changes ---
    watch(isAuthenticated, (newValue, oldValue) => {
        if (newValue !== oldValue) {
            console.log(`Auth state changed: ${oldValue} -> ${newValue}`);
            // Note: All leaderboards are now public, so no need to refetch based on auth state
            // Only modal interactions are affected by authentication
            if (!newValue) {
                // User logged out: Close any open modals
                console.log("User logged out, closing modals...");
                closePlayerTeamModal();
                closeHorsePerformanceModal();
                closeJockeyPerformanceModal();
            }
        }
    });


    // --- Return values needed by the template ---
    return {
      isAuthenticated,
      // Leaderboard states & data
      isPlayerLoading, playerError, top10Players,
      isHorseLoading, horseError, top10Horses,
      isJockeyLoading, jockeyError, top10Jockeys,
      isPeriodStatsLoading, periodStatsError, topHorseWins, topHorsePrizeSum, topHorseLeadCount, topBestDailyScores, formatEuro, formatShortDate,
      isDailyLoading, dailyError, dailyLeaderboardDate,
      sortedDailyTopHorses, sortedDailyTopJockeys, getRankFromType, // Daily horses/jockeys
      isDailyPlayerLoading, dailyPlayerError, dailyTopPlayersData, // Daily players

      // **** MODAL STATE & METHODS TO RETURN ****
      // Player Team Modal
      isPlayerTeamModalVisible,
      selectedPlayerId,
      selectedPlayerName,
      openPlayerTeamModal,
      closePlayerTeamModal,
      handleViewHorse, // Handler for event from PlayerTeamModal
      handleViewJockey, // Handler for event from PlayerTeamModal

      // Horse Performance Modal
      isHorsePerformanceModalVisible,
      selectedHorseId,
      selectedHorseName,
      openHorsePerformanceModal,
      closeHorsePerformanceModal,

      // Jockey Performance Modal
      isJockeyPerformanceModalVisible,
      selectedJockeyId,
      selectedJockeyName,
      openJockeyPerformanceModal,
      closeJockeyPerformanceModal,
      // **** END OF MODAL STATE & METHODS TO RETURN ****
    };
  }
}
</script>

<style scoped>
/* Tailwind utility classes are used primarily via global setup */
.page-content {
  padding: 20px;
  max-width: 1800px;
  margin: 0 auto;
}

/* --- Welcome Section --- */
.welcome-section {
  text-align: center;
  margin-bottom: 40px;
  padding: 30px 20px;
  background: linear-gradient(135deg, rgba(10, 25, 47, 0.95) 0%, rgba(17, 34, 64, 0.95) 100%);
  border-radius: 12px;
  box-shadow: 0 10px 30px -15px rgba(2, 12, 27, 0.7);
  border: 1px solid #1e3a5f;
  color: #e6f1ff;
}

.welcome-title {
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #64ffda;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.welcome-text {
  font-size: 1.1rem;
  max-width: 800px;
  margin: 0 auto 15px;
  line-height: 1.6;
  color: #a8b2d1;
}

.auth-prompt {
  font-size: 1rem;
  margin-top: 20px;
  padding: 15px;
  background-color: rgba(100, 255, 218, 0.1);
  border-radius: 8px;
  display: inline-block;
}

.auth-link {
  color: #64ffda;
  font-weight: 600;
  text-decoration: none;
  padding: 2px 5px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.auth-link:hover {
  background-color: rgba(100, 255, 218, 0.2);
  text-decoration: underline;
}

/* --- Twitter Feed Section --- */
.twitter-feed-section {
  margin: 2rem auto;
  max-width: 600px;
  padding: 0 1rem;
}

.twitter-feed-card {
  background: #112240;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 10px 30px -15px rgba(2, 12, 27, 0.7);
  border: 1px solid #1e3a5f;
  transition: all 0.3s ease;
}

.twitter-feed-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 30px -15px rgba(2, 12, 27, 0.8);
  border-color: rgba(100, 255, 218, 0.4);
}

.twitter-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(100, 255, 218, 0.2);
}

.twitter-icon {
  font-size: 1.5rem;
  color: #64ffda;
  font-weight: bold;
}

.twitter-header h3 {
  color: #64ffda;
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0;
}

.twitter-content {
  min-height: 400px;
  max-height: 500px;
  overflow-y: auto;
}

.twitter-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #a8b2d1;
  gap: 1rem;
}

.twitter-loading .loading-spinner {
  border: 3px solid rgba(100, 255, 218, 0.3);
  border-radius: 50%;
  border-top: 3px solid #64ffda;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.twitter-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #ff6b6b;
  text-align: center;
  gap: 1rem;
}

.twitter-fallback-link {
  color: #64ffda;
  text-decoration: none;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border: 2px solid #64ffda;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.twitter-fallback-link:hover {
  background: rgba(100, 255, 218, 0.1);
  transform: translateY(-2px);
}

/* Twitter widget styling overrides */
.twitter-embed-container iframe {
  border-radius: 8px !important;
}

/* Fallback content styling */
.twitter-fallback {
  padding: 1rem;
}

.twitter-profile-card {
  background: rgba(30, 58, 95, 0.3);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid rgba(100, 255, 218, 0.1);
}

.profile-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.profile-icon {
  font-size: 2rem;
  color: #64ffda;
}

.profile-info h4 {
  color: #64ffda;
  margin: 0 0 0.5rem 0;
  font-size: 1.2rem;
}

.profile-info p {
  color: #a8b2d1;
  margin: 0;
  font-size: 0.9rem;
}

.profile-actions {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.follow-btn, .share-btn {
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.follow-btn {
  background: #1da1f2;
  color: white;
  border: 2px solid #1da1f2;
}

.follow-btn:hover {
  background: #1a91da;
  transform: translateY(-2px);
}

.share-btn {
  background: rgba(100, 255, 218, 0.1);
  color: #64ffda;
  border: 2px solid #64ffda;
}

.share-btn:hover {
  background: rgba(100, 255, 218, 0.2);
  transform: translateY(-2px);
}

.recent-updates {
  background: rgba(100, 255, 218, 0.05);
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid rgba(100, 255, 218, 0.1);
}

.recent-updates h5 {
  color: #64ffda;
  margin: 0 0 0.75rem 0;
  font-size: 1rem;
}

.recent-updates ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.recent-updates li {
  padding: 0.5rem 0;
  color: #a8b2d1;
  font-size: 0.9rem;
  border-bottom: 1px solid rgba(100, 255, 218, 0.1);
}

.recent-updates li:last-child {
  border-bottom: none;
}

/* Responsive adjustments for Twitter section */
@media (max-width: 768px) {
  .twitter-feed-section {
    margin: 1.5rem auto;
    padding: 0 0.5rem;
  }
  
  .twitter-feed-card {
    padding: 1rem;
  }
  
  .twitter-content {
    min-height: 300px;
    max-height: 400px;
  }
  
  .twitter-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .twitter-follow-btn,
  .twitter-share-btn {
    width: 100%;
    max-width: 250px;
    justify-content: center;
  }
}

/* --- Leaderboards Container --- */
.leaderboards-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 25px;
  justify-content: center;
  margin-top: 30px;
}

/* --- General Leaderboard Section Styling --- */
.leaderboard-section {
  padding: 20px 15px;
  border: 1px solid #1e3a5f;
  border-radius: 12px;
  background-color: #112240;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  min-height: 300px;
  box-shadow: 0 10px 30px -15px rgba(2, 12, 27, 0.7);
  position: relative;
  overflow: hidden;
  width: 100%;
}

.leaderboard-section:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 30px -15px rgba(2, 12, 27, 0.8);
  border-color: rgba(100, 255, 218, 0.4);
}

.leaderboard-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #64ffda, #1e3a5f);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.leaderboard-section:hover::before {
  opacity: 1;
}

.leaderboard-section h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #e6f1ff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: 700;
  position: relative;
  padding-bottom: 10px;
}

.leaderboard-section h3::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 2px;
  background-color: #64ffda;
}

/* Styling for loading, error, no data messages */
.loading-message,
.error-message,
.no-data-message {
  color: #a8b2d1;
  text-align: center;
  margin-top: 20px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.loading-spinner {
  border: 3px solid rgba(100, 255, 218, 0.3);
  border-radius: 50%;
  border-top: 3px solid #64ffda;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-message {
  color: #ff6b6b;
  font-weight: bold;
  background-color: rgba(255, 107, 107, 0.1);
  border-radius: 8px;
  padding: 15px;
}

/* Placeholder styling */
.placeholder-text {
  font-size: 1rem;
  color: #8892b0;
  text-align: center;
}

.placeholder-icon {
  font-size: 2.5rem;
  margin-bottom: 15px;
  opacity: 0.7;
}

.leaderboard-section.placeholder {
  background-color: rgba(17, 34, 64, 0.7);
  border: 1px dashed #1e3a5f;
  justify-content: center;
  align-items: center;
  padding: 30px 20px;
}

/* Leaderboard list styling */
.leaderboard-list {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
  flex-grow: 1;
  overflow: hidden;
}

.leaderboard-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 5px;
  border-bottom: 1px solid rgba(100, 255, 218, 0.1);
  transition: background-color 0.2s ease;
  min-width: 0; /* Ensures flex items can shrink below their minimum content size */
}

.leaderboard-item:hover {
  background-color: rgba(100, 255, 218, 0.05);
}

.leaderboard-item:last-child {
  border-bottom: none;
}

.leaderboard-item .rank {
  font-weight: bold;
  min-width: 25px;
  color: #a8b2d1;
  text-align: right;
  margin-right: 8px;
}

.leaderboard-item .name {
  flex-grow: 1;
  flex-basis: 60%;
  margin: 0 10px;
  color: #64ffda;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: all 0.2s ease;
  padding-right: 5px;
}

.leaderboard-item .name.cursor-pointer {
  cursor: pointer;
}

.leaderboard-item .name.cursor-pointer:hover {
  color: #52d6c0;
  text-decoration: underline;
}

.leaderboard-item .name.opacity-50 {
  color: #8892b0;
  cursor: default;
}

.leaderboard-item .points {
  font-weight: 600;
  color: #ffb86c;
  min-width: 60px;
  text-align: right;
  white-space: nowrap;
}

.period-stats-leaderboard {
  grid-column: span 2;
}

.period-stats-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(260px, 1fr));
  gap: 16px;
}

.period-stat-column {
  background: rgba(2, 12, 27, 0.22);
  border: 1px solid rgba(100, 255, 218, 0.12);
  border-radius: 10px;
  padding: 12px;
  min-width: 0;
}

.period-stat-column h4 {
  color: #e6f1ff;
  font-size: 0.95rem;
  font-weight: 700;
  margin: 0 0 8px;
  text-align: center;
  line-height: 1.25;
}

.compact-list .leaderboard-item {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) max-content;
  column-gap: 0.75rem;
  padding: 8px 0;
}

.compact-list .leaderboard-item .rank {
  min-width: 0;
  margin-right: 0;
}

.compact-list .leaderboard-item .name {
  flex-basis: auto;
  margin: 0;
  padding-right: 0;
}

.compact-list .leaderboard-item .points {
  min-width: 0;
  font-size: 0.85rem;
}

.compact-list .leaderboard-item .daily-score-points {
  min-width: 0;
}

.stat-date {
  color: #a8b2d1;
  font-weight: 500;
}

.small-message {
  margin-top: 0;
  min-height: 80px;
  padding: 8px;
  font-size: 0.85rem;
}

/* Add date badge styling for leaderboard headers */
.leaderboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(100, 255, 218, 0.2);
}

.header-with-image {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-image {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  object-fit: cover;
  flex-shrink: 0;
}

.date-badge, .season-badge {
  font-size: 0.8rem;
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.date-badge {
  background-color: rgba(100, 255, 218, 0.15);
  color: #64ffda;
  border: 1px solid rgba(100, 255, 218, 0.3);
}

.season-badge {
  background-color: rgba(255, 184, 108, 0.15);
  color: #ffb86c;
  border: 1px solid rgba(255, 184, 108, 0.3);
}

/* --- Responsive adjustments --- */
@media (max-width: 1200px) {
  .leaderboards-container {
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  }
}

@media (max-width: 768px) {
  .welcome-title {
    font-size: 1.8rem;
  }
  
  .welcome-text {
    font-size: 1rem;
  }

  .leaderboard-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .header-with-image {
    width: 100%;
  }
  
  .date-badge, .season-badge {
    align-self: flex-start;
  }

  .period-stats-leaderboard {
    grid-column: span 1;
  }

  .period-stats-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .welcome-section {
    padding: 20px 15px;
  }
  
  .welcome-title {
    font-size: 1.5rem;
  }

  .leaderboard-section {
    padding: 15px;
  }
}

/* --- REMOVED INLINE MODAL STYLES --- */
/* Modal styles are now handled by the imported components */

</style>
